import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Layout from "../components/Layout";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import { Check } from "lucide-react";
import "../styles/coaching.css";

export default function BliOnlyfansSkaper() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isLoggedIn = !!user;
  const k = (key) => t(`bli_onlyfans.${key}`);

  const publicMethods = [
    { key: "email", label: k("form_method_email") },
    { key: "snapchat", label: "Snapchat" },
    { key: "telegram", label: "Telegram" },
    { key: "x", label: "X (Twitter)" },
  ];

  const methods = isLoggedIn
    ? [{ key: "norsk_erotikk_dm", label: k("form_method_dm") }, ...publicMethods]
    : publicMethods;

  const [method, setMethod] = useState(isLoggedIn ? "norsk_erotikk_dm" : "email");
  const [handle, setHandle] = useState("");
  const [hasExisting, setHasExisting] = useState(false);
  const [ofLinks, setOfLinks] = useState("");
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (method === "norsk_erotikk_dm" && user?.username) {
      setHandle(user.username);
    } else if (method !== "norsk_erotikk_dm" && handle === user?.username) {
      setHandle("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [method, user]);

  const submit = async (e) => {
    e.preventDefault();
    if (!handle.trim()) {
      toast.error(k("form_err_handle"));
      return;
    }
    if (message.trim().length < 3) {
      toast.error(k("form_err_message") || "Skriv en kort melding om hva du trenger hjelp med (minst 3 tegn).");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/coaching-inquiries", {
        contact_method: method,
        contact_handle: handle.trim(),
        has_existing_account: hasExisting,
        existing_of_links: hasExisting ? ofLinks.trim() : "",
        message: message.trim(),
      });
      setDone(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      toast.error(err.response?.data?.detail || k("form_err_generic"));
    } finally {
      setSubmitting(false);
    }
  };

  // Helper to render bullet item with bold heading + paragraph
  const OfferBullet = ({ idx }) => (
    <li>
      <strong>{k(`s_offer_b${idx}_h`)}</strong> – {k(`s_offer_b${idx}_p`)}
    </li>
  );

  return (
    <Layout withSidebar={false}>
      <article className="of-page" data-testid="bli-onlyfans-page">
        {done && (
          <div className="of-success" data-testid="of-success-panel">
            <h2><Check className="inline h-6 w-6 mr-2" style={{ color: "#5BA5C9" }} />{k("success_h")}</h2>
            <p>
              {k("success_thanks")}{" "}
              <strong>
                {method === "norsk_erotikk_dm"
                  ? k("success_dm_label")
                  : `${methods.find((m) => m.key === method)?.label} (${handle})`}
              </strong>{" "}
              {k("success_within")}
            </p>
            <p>
              {k("success_remember")}{" "}
              {hasExisting ? (
                <>{k("success_existing")}</>
              ) : (
                <><strong>{k("success_new_pre")}</strong> {k("success_new_post")}</>
              )}
            </p>
            <p style={{ marginTop: "1.5rem" }}>
              <em>{k("success_nospam")}</em>
            </p>
          </div>
        )}

        <h1>
          {k("h1_pre")} <span className="accent">{k("h1_accent")}</span>{k("h1_post")}
        </h1>
        <p className="of-lead">{k("lead")}</p>

        <p>{k("intro_p")}</p>

        <h2>{k("s_who_h")}</h2>
        <p>
          <strong>{k("s_who_starter_b")}</strong> {k("s_who_starter_p1")}
        </p>
        <p>{k("s_who_starter_p2")}</p>
        <p>
          <strong>{k("s_who_existing_b")}</strong> {k("s_who_existing_p")}
        </p>

        <h2>{k("s_what_h")}</h2>
        <p>{k("s_what_p1")}</p>
        <p>{k("s_what_p2")}</p>
        <p>{k("s_what_p3")}</p>

        <h2>{k("s_think_h")}</h2>

        <h3>{k("s_anon_h")}</h3>
        <p>{k("s_anon_p1")}</p>
        <p>{k("s_anon_p2")}</p>

        <h3>{k("s_time_h")}</h3>
        <p>{k("s_time_p1")}</p>
        <p>{k("s_time_p2")}</p>

        <h3>{k("s_tax_h")}</h3>
        <p>{k("s_tax_p")}</p>

        <h2>{k("s_exp_h")}</h2>
        <p>{k("s_exp_p1")}</p>
        <p>{k("s_exp_p2")}</p>
        <p>{k("s_exp_p3")}</p>

        <h2>{k("s_mental_h")}</h2>
        <p>{k("s_mental_p1")}</p>
        <p>
          <strong>{k("s_mental_fam_b")}</strong> {k("s_mental_fam_p")}
        </p>
        <p>
          <strong>{k("s_mental_honest_b")}</strong> {k("s_mental_honest_p")}
        </p>
        <p>
          <strong>{k("s_mental_compete_b")}</strong> {k("s_mental_compete_p")}
        </p>

        <h2>{k("s_sec_h")}</h2>
        <ul className="of-bullets">
          <li><strong>{k("s_sec_b1_h")}</strong> {k("s_sec_b1_p")}</li>
          <li><strong>{k("s_sec_b2_h")}</strong> {k("s_sec_b2_p")}</li>
          <li><strong>{k("s_sec_b3_h")}</strong> {k("s_sec_b3_p")}</li>
        </ul>

        <h2>{k("s_men_h")}</h2>
        <p>{k("s_men_p1")}</p>
        <p>{k("s_men_p2")}</p>
        <p>{k("s_men_p3")}</p>

        <h2>{k("s_offer_h")}</h2>
        <ul className="of-bullets">
          {[1, 2, 3, 4, 5, 6].map((i) => <OfferBullet key={i} idx={i} />)}
        </ul>
        <p>
          {k("s_offer_own_pre")} <strong>{k("s_offer_own_b")}</strong> {k("s_offer_own_post")}
        </p>
        <p>{k("s_offer_freedom")}</p>

        <div className="of-warn">
          <h3>{k("warn_h")}</h3>
          <p style={{ color: "var(--cream-soft)" }}>{k("warn_p1")}</p>
          <p style={{ color: "var(--cream-soft)", marginBottom: 0 }}>{k("warn_p2")}</p>
        </div>
        <p>
          <strong>{k("warn_existing_b")}</strong> {k("warn_existing_p")}
        </p>

        <h2 id="kontakt">{k("form_h")}</h2>
        <p>{k("form_intro")}</p>

        <form className="of-form" onSubmit={submit} data-testid="of-contact-form">
          <label className="of-label">{k("form_method_label")}</label>
          <div className="of-method-grid" style={methods.length === 5 ? { gridTemplateColumns: "repeat(2, 1fr)" } : undefined}>
            {methods.map((m) => (
              <button type="button" key={m.key}
                onClick={() => setMethod(m.key)}
                className={`of-method ${method === m.key ? "is-active" : ""}`}
                data-testid={`of-method-${m.key}`}>
                {m.key === "norsk_erotikk_dm" ? k("form_method_dm_full") : m.label}
              </button>
            ))}
          </div>
          {isLoggedIn && method === "norsk_erotikk_dm" && (
            <p style={{ fontSize: "0.85rem", color: "var(--cream-soft)", marginTop: "0.5rem", marginBottom: "0.5rem", fontStyle: "italic" }}>
              {k("form_method_dm_note_pre")} <strong style={{ color: "var(--cream)" }}>@{user.username}</strong> {k("form_method_dm_note_post")}
            </p>
          )}

          {method !== "norsk_erotikk_dm" && (
            <>
              <label className="of-label" htmlFor="of-handle">
                {method === "email"
                  ? k("form_handle_email")
                  : `${k("form_handle_other")} ${methods.find((m) => m.key === method).label}`}
              </label>
              <input id="of-handle"
                type={method === "email" ? "email" : "text"}
                value={handle}
                onChange={(e) => setHandle(e.target.value)}
                maxLength={200}
                placeholder={method === "email" ? k("form_email_placeholder") : k("form_handle_placeholder")}
                className="input-editorial w-full"
                data-testid="of-contact-handle"
                required
              />
            </>
          )}

          <label className="of-existing">
            <input type="checkbox" checked={hasExisting}
              onChange={(e) => setHasExisting(e.target.checked)}
              data-testid="of-has-existing" />
            <span>{k("form_existing_label")}</span>
          </label>

          {hasExisting && (
            <>
              <label className="of-label" htmlFor="of-existing-links">{k("form_existing_links_label")}</label>
              <input id="of-existing-links"
                type="text"
                value={ofLinks}
                onChange={(e) => setOfLinks(e.target.value)}
                maxLength={500}
                placeholder={k("form_existing_links_placeholder")}
                className="input-editorial w-full"
                data-testid="of-existing-links"
              />
              <p style={{ fontSize: "0.78rem", color: "var(--cream-faint)", marginTop: "0.35rem" }}>
                {k("form_existing_links_hint")}
              </p>
            </>
          )}

          <label className="of-label" htmlFor="of-message">
            {k("form_message_label")} <span style={{ color: "var(--magenta)" }}>*</span>
          </label>
          <textarea id="of-message"
            rows={5}
            minLength={3}
            maxLength={2000}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder={k("form_message_placeholder")}
            className="input-editorial w-full"
            data-testid="of-message"
            required
          />
          <div style={{ fontSize: "0.75rem", color: "var(--cream-faint)", textAlign: "right", marginTop: "0.25rem" }}>
            {message.length}/2000
          </div>

          <button type="submit" disabled={submitting || done}
            className="of-submit" data-testid="of-submit">
            {submitting ? k("form_submitting") : done ? k("form_sent") : k("form_submit")}
          </button>

          <p className="of-foot">{k("form_foot")}</p>
        </form>

        <h2>{k("faq_h")}</h2>
        <div className="of-faq">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <details key={i}>
              <summary>{k(`faq_q${i}`)}</summary>
              <p>{k(`faq_a${i}`)}</p>
            </details>
          ))}
        </div>

        <p style={{ marginTop: "2.5rem", fontSize: "0.85rem", color: "var(--cream-faint)", fontStyle: "italic" }}>
          {k("faq_foot")}
        </p>
      </article>
    </Layout>
  );
}
